import React from "react";
import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ActionTypes } from "../../state/constantes/ActionTypes";
import { styled } from "@mui/material/styles";
import * as deleteActions from "../../state/actions/ShimpentDeleteAction";
import * as refreshActions from "../../state/actions/ShipmentRefreshAction";
import { connect } from "react-redux";
import AlertDialog from "../../../../common/components/Dialog";
import NtnEquipementStatesTimeLineExport from "./NtnEquipementStatesTimeLineExport";
import NtnEquipementStatesTimeLineImport from "./NtnEquipementStatesTimeLineImport";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function NtnRow(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  const [showRefreshDialog, setShowRefreshDialog] = React.useState(false);

  function handleCancel() {
    setShowDeleteDialog(false);
    setShowRefreshDialog(false);
  }

  function handleConfirmDelete(id) {
    props.handleDeleteItem({
      type: ActionTypes.ACTION_SHIPMENT_DELETE_START,
      payload: id,
      data: props.shipmentByUser.data,
    });
    setShowDeleteDialog(false);
  }

  function handleConfirmRefresh(id) {
    props.handleRefreshItem({
      type: ActionTypes.ACTION_SHIPMENT_REFRESH_START,
      payload: id,
      data: props.shipmentByUser.data,
    });
    setShowRefreshDialog(false);
  }

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.idEquipment}</TableCell>
        <TableCell>{row.port}</TableCell>
        <TableCell>{row.customsStatus}</TableCell>
        <TableCell>
          {row?.portcall?.list[0]?.eTA?.substring(0, 16)} -{" "}
          {row?.portcall?.list[0]?.eTD?.substring(0, 16)}
        </TableCell>
        <TableCell>{row.dateMaj?.substring(0, 16)}</TableCell>
        <TableCell>
          <DeleteForeverIcon
            style={{
              cursor: "pointer",
              color: "#232f66",
              marginLeft: "30%",
            }}
            id={row.id}
            onClick={() => setShowDeleteDialog(true)}
          ></DeleteForeverIcon>
          <AlertDialog
            show={showDeleteDialog}
            title={"Supprimer"}
            description={"Voulez vous supprimer ce conteneur ?"}
            confirm={() => handleConfirmDelete(row.id)}
            cancel={() => handleCancel()}
          ></AlertDialog>
          {/*&nbsp;&nbsp;&nbsp;
          <RefreshIcon
            style={{ cursor: "pointer", color: "#232f66" }}
            id={row.id}
            onClick={() => setShowRefreshDialog(true)}
          ></RefreshIcon>
          <AlertDialog
            show={showRefreshDialog}
            title={"Raffrichir"}
            description={
              "Cette operation vous coutera des frais, Voulez vous raffrichier les informations de ce conteneur ?"
            }
            confirm={() => handleConfirmRefresh(row.id)}
            cancel={() => handleCancel()}
          ></AlertDialog>*/}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {row.bookingNumber == null || row.bookingNumber == "" ? (
                <NtnEquipementStatesTimeLineImport
                  data={{ row }}
                ></NtnEquipementStatesTimeLineImport>
              ) : (
                <NtnEquipementStatesTimeLineExport
                  data={{ row }}
                ></NtnEquipementStatesTimeLineExport>
              )}

              <Typography variant="h6" gutterBottom component="div">
                Informations conteneur
              </Typography>

              <Table size="small" aria-label="purchases">
                <TableBody>
                  <StyledTableRow>
                    <TableCell>Port : {row.port}</TableCell>
                    <TableCell>N° Conteneur : {row.idEquipment}</TableCell>
                    <TableCell>
                      Nom du terminal : {row.terminalOperatorName}
                    </TableCell>
                    <TableCell>N° voyage : {row.idPortCall}</TableCell>
                  </StyledTableRow>
                  <TableRow>
                    <TableCell>
                      Entrant/Sortant :{" "}
                      {row.inbound == "O" ? "Sortant" : "Entrant"}
                    </TableCell>
                    <TableCell>Transporteur : {row.carrier}</TableCell>
                    <TableCell>
                      Type équipement : {row.typeOfEquipment}
                    </TableCell>
                    <TableCell>
                      N° Connaissement :{" "}
                      {row.blNumber != null ? row.blNumber : row.blnumber}
                    </TableCell>
                  </TableRow>
                  <StyledTableRow>
                    <TableCell>N° Booking : {row.bookingNumber}</TableCell>
                    <TableCell>Poids Brut : {row.grossWeight} Tn</TableCell>
                    <TableCell>
                      Poids Net : {row.netWeight}{" "}
                      {row.netWeight != null ? " Tn" : ""}
                    </TableCell>
                    <TableCell>
                      Marchandises dangereuses :{" "}
                      {row.dangerousGoods === true ? "Oui" : "Non"}
                    </TableCell>
                  </StyledTableRow>
                  <TableRow>
                    <TableCell>
                      Transbordement :{" "}
                      {row.transhipment === true ? "Oui" : "Non"}
                    </TableCell>
                    <TableCell>Statut douanier : {row.customsStatus}</TableCell>
                    <TableCell>
                      Date main levée :{" "}
                      {row.customsClearanceDateTime?.substring(0, 16)}
                    </TableCell>
                    <TableCell>
                      Date entrée au terminal :{" "}
                      {row.gateInDateTime?.substring(0, 16)}
                    </TableCell>
                  </TableRow>
                  <StyledTableRow>
                    <TableCell>
                      Date sortie du terminal :{" "}
                      {row.gateOutDateTime?.substring(0, 16)}
                    </TableCell>
                    <TableCell>
                      date chargement : {row.loadedDateTime?.substring(0, 16)}
                    </TableCell>
                    <TableCell>
                      date déchargement :{" "}
                      {row.dischargedDateTime?.substring(0, 16)}
                    </TableCell>
                    <TableCell>
                      Date livraison vide : {row.emptyDeliveredDateTime}
                    </TableCell>
                  </StyledTableRow>
                  <TableRow>
                    <TableCell>
                      Type de transport d'entrée :{" "}
                      {row.inboundMeansOfTransportType}
                    </TableCell>
                    <TableCell>
                      Nom du transport d'entrée :{" "}
                      {row.inboundMeansOfTransportName}
                    </TableCell>
                    <TableCell>
                      Type de transport de sortie :{" "}
                      {row.outboundMeansOfTransportType}
                    </TableCell>
                    <TableCell>
                      Nom du transport de sortie:{" "}
                      {row.outboundMeansOfTransportName}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {row.portcall && (
                <>
                  <Typography variant="h6" gutterBottom component="div">
                    Informations navire
                  </Typography>
                  <Table size="small" aria-label="purchases">
                    {row.portcall?.list?.map((record) => (
                      <TableBody>
                        <StyledTableRow>
                          <TableCell>Port : {record.port}</TableCell>
                          <TableCell>
                            IMO du navire : {record.iMOVessel}
                          </TableCell>
                          <TableCell>
                            Nom du navire : {record.vesselName}
                          </TableCell>
                          <TableCell>N° voyage : {record.idPortCall}</TableCell>
                        </StyledTableRow>
                        <TableRow>
                          <TableCell>
                            ETA : {record.eTA?.substring(0, 16)}
                          </TableCell>
                          <TableCell>
                            ATA: {record.aTA?.substring(0, 16)}
                          </TableCell>
                          <TableCell>
                            ETD : {record.eTD?.substring(0, 16)}
                          </TableCell>
                          <TableCell>
                            ATD : {record.aTD?.substring(0, 16)}
                          </TableCell>
                        </TableRow>
                        <StyledTableRow>
                          <TableCell>callSign : {record.callSign}</TableCell>
                        </StyledTableRow>
                      </TableBody>
                    ))}
                  </Table>
                </>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleDeleteItem: (action) => {
      dispatch(deleteActions.shipmentDeleteStart(action));
    },
    handleRefreshItem: (action) => {
      dispatch(refreshActions.shipmentRefreshStart(action));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    shipmentByUser: state.ShipmentByUserReducer,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NtnRow);
